import * as React from "react";
import SearchIcon from "../../icons/Search";
import { Input } from "../Input/Input";
import { cn } from "../../../helpers";
import styles from "./SearchInput.module.scss";

export interface SearchInputProps
    extends React.InputHTMLAttributes<HTMLInputElement> {
    containerClass?: string;
    inputClass?: string;
}

export function SearchInput({
    containerClass,
    inputClass,
    ...props
}: SearchInputProps) {
    return (
        <div className={cn(styles.container, containerClass)}>
            <SearchIcon stroke="#576A81" />
            <Input
                inputSize="small"
                className={cn(styles.input, inputClass)}
                {...props}
            />
        </div>
    );
}
